// ── Tracks & Groups ──────────────────────────────────────────────────────────
// Tracks replaced the old "Spaces & Tracks" board: a flat, filterable library of
// containers, each owned by a Group. Groups control who can see a track.
// ─────────────────────────────────────────────────────────────────────────────

export type TrackType = 'area' | 'project' | 'exploration' | 'product / skills backlog';
export type TrackStatus = 'active' | 'dormant' | 'archived';
export interface Track {
  name: string;
  group: string;
  type: TrackType;
  status: TrackStatus;
}
export const GROUP_NAMES = ['Giga Master', 'Giga Marketing', 'Everyone', 'No Contact Private', 'NoContact Ops', "Faith's Private Space", 'Demo'];
export const TRACKS: Track[] = [{
  name: 'Affiliate Marketing',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Base',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'CEO Journey',
  group: 'No Contact Private',
  type: 'area',
  status: 'active'
}, {
  name: 'Content',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Developer VM Stuff',
  group: 'Everyone',
  type: 'area',
  status: 'active'
}, {
  name: 'Early User Activation',
  group: 'Giga Master',
  type: 'project',
  status: 'active'
}, {
  name: 'Ember',
  group: 'NoContact Ops',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga',
  group: 'Giga Master',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga Creator Outreach',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga Design System',
  group: 'Giga Master',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga Marketing & GTM',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga Ops',
  group: 'Giga Master',
  type: 'project',
  status: 'active'
}, {
  name: 'Giga Product',
  group: 'Giga Master',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga Product Strategy',
  group: 'Giga Master',
  type: 'exploration',
  status: 'active'
}, {
  name: 'Giga SEO',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Giga User Friendliness',
  group: 'Giga Master',
  type: 'project',
  status: 'active'
}, {
  name: 'Giga Website',
  group: 'Giga Master',
  type: 'area',
  status: 'active'
}, {
  name: 'Integrations Progress',
  group: 'Giga Master',
  type: 'area',
  status: 'active'
}, {
  name: 'Naming Containers',
  group: 'Giga Master',
  type: 'project',
  status: 'active'
}, {
  name: 'Paid Advertising',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'September 1 Product Launch',
  group: 'Giga Marketing',
  type: 'project',
  status: 'active'
}, {
  name: 'Skills to Build for Giga Users',
  group: 'Giga Master',
  type: 'product / skills backlog',
  status: 'active'
}, {
  name: 'The New Way',
  group: 'Giga Master',
  type: 'exploration',
  status: 'active'
}, {
  name: 'Tony Personal',
  group: "Faith's Private Space",
  type: 'area',
  status: 'active'
}, {
  name: 'Twitter Account',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Twitter Inbox Management',
  group: "Faith's Private Space",
  type: 'project',
  status: 'active'
}, {
  name: 'Usage Tracking',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Victor Ad Analysis',
  group: 'Giga Marketing',
  type: 'exploration',
  status: 'active'
}, {
  name: 'Viral Content Formats Reference',
  group: 'Giga Marketing',
  type: 'area',
  status: 'active'
}, {
  name: 'Q2 Retro',
  group: 'Giga Master',
  type: 'project',
  status: 'dormant'
}, {
  name: 'Old Brand Guidelines',
  group: 'Giga Marketing',
  type: 'area',
  status: 'dormant'
}, {
  name: 'Beta Waitlist Push',
  group: 'Giga Marketing',
  type: 'project',
  status: 'archived'
}, {
  name: 'Demo Sandbox',
  group: 'Demo',
  type: 'exploration',
  status: 'archived'
}];
export interface Group {
  name: string;
  shared: boolean;
  members: number;
  tracks: number;
  files: number;
  connections: number;
  tables: number;
}
export const GROUPS: Group[] = [{
  name: 'Giga Master',
  shared: true,
  members: 18,
  tracks: 11,
  files: 342,
  connections: 14,
  tables: 6
}, {
  name: 'Giga Marketing',
  shared: true,
  members: 9,
  tracks: 12,
  files: 208,
  connections: 8,
  tables: 4
}, {
  name: 'Everyone',
  shared: true,
  members: 18,
  tracks: 1,
  files: 46,
  connections: 3,
  tables: 1
}, {
  name: 'NoContact Ops',
  shared: true,
  members: 5,
  tracks: 1,
  files: 88,
  connections: 6,
  tables: 2
}, {
  name: 'No Contact Private',
  shared: false,
  members: 2,
  tracks: 1,
  files: 24,
  connections: 2,
  tables: 0
}, {
  name: "Faith's Private Space",
  shared: false,
  members: 1,
  tracks: 2,
  files: 61,
  connections: 4,
  tables: 1
}, {
  name: 'Demo',
  shared: true,
  members: 4,
  tracks: 1,
  files: 12,
  connections: 1,
  tables: 0
}];